import { InputProps } from 'antd/lib/input';
import React from 'react';
import Button from '@ui-library/button';
import { Flex } from '@ui-library/misc';
import { FixMe } from '@utils/types';
import { useModal } from '@ui-library/modal/ModalProvider';

interface ModalFooterProps extends InputProps {
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  disabled?: boolean;
  onCancel?: () => void;
  removeCancel?: boolean;
  closeOnConfirm?: boolean; // default true
}

const ModalFooter = ({
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onCancel,
  disabled,
  removeCancel,
  closeOnConfirm = true,
}: ModalFooterProps) => {
  const modal = useModal();
  const onCancelCL = React.useCallback(async () => {
    let onCancelResult: FixMe = true;
    if (onCancel) {
      onCancelResult = await onCancel();
    }
    if (onCancelResult !== false) {
      modal.close();
    }
  }, [onCancel]);
  const onConfirmCL = React.useCallback(async () => {
    let onConfirmResult: FixMe = true;
    if (onConfirm) {
      onConfirmResult = await onConfirm();
    }
    if (closeOnConfirm && onConfirmResult !== false) {
      modal.close();
    }
  }, [onConfirm, closeOnConfirm]);
  return (
    <Flex style={{ justifyContent: 'flex-end', marginTop: 24 }}>
      {!removeCancel && (
        <Button secondary onClick={onCancelCL} style={{ marginRight: 8 }} name={cancelText} />
      )}
      <Button disabled={disabled} onClick={onConfirmCL} name={confirmText} />
    </Flex>
  );
};

export default ModalFooter;
